import { Base } from '@or-sdk/base';
import { CustomersApi, EnvironmentsApi, AccountsApi, UsersApi, CategoriesApi, MappingApi, FlowsApi, ReportingApi, SkusApi, PermissionsApi, ThresholdsApi, } from './api';
import { ApiError } from './apiError';
import { SERVICE_KEY } from './constants';
export class Ccp extends Base {
    constructor(params) {
        const { token, discoveryUrl, ccpApiUrl } = params;
        super({
            token,
            discoveryUrl,
            serviceUrl: ccpApiUrl,
            serviceKey: SERVICE_KEY,
        });
        const apiCall = this.callApi.bind(this);
        this.withApiErrorLog = Boolean(params.withApiErrorLog);
        this.customersApi = new CustomersApi(apiCall);
        this.environmentsApi = new EnvironmentsApi(apiCall);
        this.accountsApi = new AccountsApi(apiCall);
        this.usersApi = new UsersApi(apiCall);
        this.categoriesApi = new CategoriesApi(apiCall);
        this.mappingApi = new MappingApi(apiCall);
        this.flowsApi = new FlowsApi(apiCall);
        this.reportingApi = new ReportingApi(apiCall);
        this.skusApi = new SkusApi(apiCall);
        this.permissionsApi = new PermissionsApi(apiCall);
        this.thresholdsApi = new ThresholdsApi(apiCall);
    }
    callApi(params) {
        return super.callApiV2(params);
    }
    parseError(e) {
        if (e.isAxiosError) {
            const { code, message, stack } = e;
            if (this.withApiErrorLog) {
                this.logApiError(e);
            }
            return new ApiError(code, message, stack);
        }
        const parsedError = super.parseError(e);
        return parsedError;
    }
    logApiError(e) {
        var _a, _b, _c;
        console.error(`url           : ${(_a = e.config) === null || _a === void 0 ? void 0 : _a.url}`);
        console.error(`method        : ${e.request.method}`);
        console.error(`params        : ${JSON.stringify(((_b = e.config) === null || _b === void 0 ? void 0 : _b.params) || {})}`);
        console.error(`data          : ${(() => {
            var _a;
            const str = JSON.stringify(((_a = e.config) === null || _a === void 0 ? void 0 : _a.data) || {});
            return str.length > 150 ? str.slice(0, 149) + '...' : str;
        })()}`);
        console.error(`status code   : ${e.request.res.statusCode}`);
        console.error(`status message: ${e.request.res.statusMessage}`);
        console.error(`authorization : ${(_c = e.config) === null || _c === void 0 ? void 0 : _c.headers.Authorization}`);
    }
}
//# sourceMappingURL=Ccp.js.map